exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imageDragPreview__image___XeaKX {\n  width: 160px;\n  height: 120px;\n  box-shadow: 0px 0px 2px 2px #f94144;\n  object-fit: cover; }\n", ""]);

// exports
exports.locals = {
	"image": "imageDragPreview__image___XeaKX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/PhotoUploader/MultiplePhotos/ImageCard/ImageDragPreview/imageDragPreview.scss
// module id = 2262
// module chunks = 6